import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "tooltip"]

  show() {
    const tooltip = this.tooltipTarget
    const trigger = this.triggerTarget

    tooltip.classList.remove("hidden")
    tooltip.classList.add("flex")

    // Position tooltip to the left of the trigger, vertically centered
    const triggerRect = trigger.getBoundingClientRect()
    const tooltipRect = tooltip.getBoundingClientRect()

    const top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2)
    const left = triggerRect.left - tooltipRect.width - 6

    tooltip.style.top = `${top}px`
    tooltip.style.left = `${left}px`
  }

  hide() {
    const tooltip = this.tooltipTarget
    tooltip.classList.add("hidden")
    tooltip.classList.remove("flex")
  }
}
